import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AppContentsService } from '../../../services/app-contents.service';
import { ActivatedRoute } from '@angular/router';
import { ISubscription } from 'rxjs/Subscription';
import { CriticalEditionService } from '../../../services/critical-edition.service';
import { GetCeStructureTitlePipe } from '../../../pipes/get-ce-structure-title.pipe';
import { globals } from '../../../../globals';

@Component({
  selector: 'app-page-critical-edition-structure-intro',
  templateUrl: './page-critical-edition-structure-intro.component.html',
  styleUrls: ['./page-critical-edition-structure-intro.component.css']
})
export class PageCriticalEditionStructureIntroComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    lastUpdate: string;
    title: SafeHtml;
    description: SafeHtml;

    constructor(
        private sanitizer: DomSanitizer,
        private activeRoute: ActivatedRoute,
        private criticalEditionService: CriticalEditionService,
        private appContentsService: AppContentsService,
        private getCeStructureTitlePipe: GetCeStructureTitlePipe
    ) {
    }

    ngOnInit(): void {
        this.title = globals.html_small_loading_gif;
        this.description = globals.html_small_loading_gif;

        /* Page contents */
        this.subscriptions.push(
            this.activeRoute.params.subscribe(
                params => {
                    this.title = globals.html_small_loading_gif;
                    if (params['cedId']) {
                        const cedId = params['cedId'];
                        this.subscriptions.push(
                            this.criticalEditionService.getStructureTree(this.isEditionSample()).subscribe(
                                ceStructureTree => {
                                    if (ceStructureTree && ceStructureTree.length > 0) {
                                        const ceStructNode = ceStructureTree.find(treeNode => treeNode.id === cedId);
                                        if (ceStructNode) {
                                            this.title = this.getCeStructureTitlePipe.transform(ceStructNode, ' - Introduction');
                                            const pageContentId = ceStructNode.type + '_' + cedId;
                                            this.subscriptions.push(
                                                this.appContentsService.getPageContents(pageContentId).subscribe(
                                                    page => {
                                                        if (page && page.name === pageContentId) {
                                                            this.lastUpdate = page.pubLastDate;
                                                            const pageDescription = page.contents.find(c => c.name === 'description');
                                                            if (pageDescription) {
                                                                this.description = this.sanitizer.bypassSecurityTrustHtml(pageDescription.text);
                                                            }
                                                        }
                                                    },
                                                    err => console.error(err)
                                                )
                                            );
                                        }
                                    }
                                },
                                err => console.error(err)
                            )
                        );
                    }
                },
                err => console.error(err)
            )
        );
    }

    private isEditionSample() {
        return !!this.activeRoute.snapshot.url.find(
            function (url) {
                return url.path === 'sample';
            }
        );
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/pages/page-critical-edition-structure-intro/page-critical-edition-structure-intro.component.ts